import { render } from "./SysNoteManager.vue?vue&type=template&id=ff3815e8&scoped=true"
import script from "./SysNoteManager.vue?vue&type=script&lang=js"
export * from "./SysNoteManager.vue?vue&type=script&lang=js"

import "./SysNoteManager.vue?vue&type=style&index=0&id=ff3815e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff3815e8"]])

export default __exports__